module.exports = __webpack_public_path__ + "img/backhoe_driving.326524b5.svg";